import { combineReducers } from 'redux';

import alert from './alertReducer';
import chat from './chatInitReducer';
import filters from './filtersReducer';
import insiders from './insidersReducer';
import luser from './luserReducer';
import messageForm from './messageFormReducer';
import settings from './settingsReducer';
import threads from './threadsReducer';

export default combineReducers({
  chat,
  luser,
  insiders,
  threads,
  filters,
  settings,
  alert,
  messageForm
});



// WEBPACK FOOTER //
// ./src/redux/reducers/index.jsx